// PULL TO REFRESH CONSTANTS
const namespace = `PULL_TO_REFRESH`;
export const PULL_TO_REFRESH_CONSTANTS = {
  PULL_TO_REFRESH_OPEN: `${namespace}_OPEN`,
  PULL_TO_REFRESH_CLOSE: `${namespace}_CLOSE`,
  PULL_TO_REFRESH_TRIGGER: `${namespace}_TRIGGER`,
  PULL_TO_REFRESH_UNTRIGGER: `${namespace}_UNTRIGGER`,
};

// PULL TO REFRESH INITIAL STATE
const pullToRefreshInitialState = {
  isPullToRefreshOpen: false,
  isPullToRefreshTriggered: false,
};

// PULL TO REFRESH ACTIONS
export const openPullToRefreshAction = () => {
  return {
    type: PULL_TO_REFRESH_CONSTANTS.PULL_TO_REFRESH_OPEN,
  };
};
export const closePullToRefreshAction = () => {
  return {
    type: PULL_TO_REFRESH_CONSTANTS.PULL_TO_REFRESH_CLOSE,
  };
};
export const triggerPullToRefreshAction = () => {
  return {
    type: PULL_TO_REFRESH_CONSTANTS.PULL_TO_REFRESH_TRIGGER,
  };
};
export const unTriggerPullToRefreshAction = () => {
  return {
    type: PULL_TO_REFRESH_CONSTANTS.PULL_TO_REFRESH_UNTRIGGER,
  };
};

// STATE ALTERING FUNCTIONS
const openPullToRefresh = () => {
  return {
    isPullToRefreshOpen: true,
  };
};
const closePullToRefresh = () => {
  return {
    isPullToRefreshOpen: false,
  };
};
const triggerPullToRefresh = () => {
  return {
    isPullToRefreshTriggered: true,
  };
};
const untriggerPullToRefresh = () => {
  return {
    isPullToRefreshTriggered: false,
  };
};

// PULL TO REFRESH REDUCER
const pullToRefreshReducer = (state = pullToRefreshInitialState, action) => {
  switch (action.type) {
    case PULL_TO_REFRESH_CONSTANTS.PULL_TO_REFRESH_OPEN: {
      return { ...state, ...openPullToRefresh() };
    }
    case PULL_TO_REFRESH_CONSTANTS.PULL_TO_REFRESH_CLOSE: {
      return { ...state, ...closePullToRefresh() };
    }
    case PULL_TO_REFRESH_CONSTANTS.PULL_TO_REFRESH_TRIGGER: {
      return { ...state, ...triggerPullToRefresh() };
    }
    case PULL_TO_REFRESH_CONSTANTS.PULL_TO_REFRESH_UNTRIGGER: {
      return { ...state, ...untriggerPullToRefresh() };
    }
    default: {
      return state;
    }
  }
};

export default pullToRefreshReducer;
